import { selectCurrentEntities } from 'ducks/entities/selectors'
import { createSelector } from 'reselect'
import { emptyArr } from 'util/arrays'

export const selectInaccessibleMailboxesRaw = createSelector(
  state => selectCurrentEntities(state, 'channel') || emptyArr,
  channels => channels.filter(channel => !channel.hasAccess)
)
